/** @override King Living: FullBlogFragment — blogTileImage union Image | ShopTheLook (base fragments). */

import gql from 'graphql-tag';

import {BaseBlogFragment} from './base-blog.fragment';
import {BaseImageFragment} from '@amblique/contentful/app/contentful/fragments/image/base-image.fragment';
import {LinkFragment} from '@amblique/contentful/app/contentful/fragments/link/link.fragment';
import {BaseShopTheLookFragment} from '@amblique/contentful/app/contentful/fragments/shop-the-look/base-shop-the-look.fragment';

export const FullBlogFragment = gql`
  ${BaseBlogFragment}
  ${BaseImageFragment}
  ${BaseShopTheLookFragment}
  ${LinkFragment}

  fragment FullBlogFragment on Blog {
    ...BaseBlogFragment

    blogTileImage {
      __typename
      ... on Image {
        ...BaseImageFragment
      }
      ... on ShopTheLook {
        ...BaseShopTheLookFragment
      }
    }
    shareThisPostCollection {
      items {
        __typename
        ... on Link {
          ...LinkFragment
        }
      }
    }
    shareThisPostCursorCollection {
      items {
        __typename
        ... on Link {
          ...LinkFragment
        }
      }
    }
  }
`;
